// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1XhNU","item":"PaymentsMobile_item__2hSH_","label":"PaymentsMobile_label__2BzJh","amount":"PaymentsMobile_amount__YZZuJ"};